'use strict';


var React = require('react/addons');
var CodeSnippet = require('./code-snippet');
var Choice = require('../../');
var _ = require('lodash');

var POKEMON = require('../data/pokemon.js');

var PokemonRenderer = React.createClass({
  displayName: 'PokemonRenderer',

  mixins: [Choice.OptionMixin],

  render: function render() {
    var pokemon = this.props.pokemon;

    var weight = pokemon.weight / 10;
    var height = pokemon.height / 10;

    return React.createElement(
      'div',
      { className: 'pokemon' },
      React.createElement(
        'div',
        { className: 'pokemon__image' },
        React.createElement('img', { src: pokemon.image })
      ),
      React.createElement(
        'div',
        { className: 'pokemon__name' },
        React.createElement(
          'span',
          { className: 'pokemon__number' },
          '#',
          pokemon.national_id
        ),
        React.createElement(
          Choice.TextHighlight,
          { tokens: this.props.tokens },
          pokemon.name
        ),
        React.createElement(
          'div',
          { className: 'pokemon__attributes' },
          'HP: ',
          pokemon.hp,
          ' | Height: ',
          height,
          ' m | Weight: ',
          weight,
          ' kg'
        )
      )
    );
  }
});

var customExample = "var Choice = require('react-choice');\n\nvar PokemonRenderer = React.createClass({\n  // The option mixin provides proptypes that the component requires\n  mixins: [Choice.OptionMixin],\n\n  render: function() {\n    var pokemon = this.props.pokemon;\n\n    return (\n      <div className=\"pokemon\">\n        <div className=\"pokemon__image\">\n          <img src={pokemon.image} />\n        </div>\n        <div className=\"pokemon__name\">\n          <span className=\"pokemon__number\">\n            #{pokemon.national_id}\n          </span>\n          <Choice.TextHighlight tokens={this.props.tokens}>\n            {pokemon.name}\n          </Choice.TextHighlight>\n          <div className=\"pokemon__attributes\">\n            HP: {pokemon.hp} | Height: {pokemon.height} m | Weight: {pokemon.weight} kg\n          </div>\n        </div>\n      </div>\n    );\n  }\n});\n\nvar options = POKEMON.map(function(pokemon) {\n  return (\n    <PokemonRenderer value={pokemon.national_id} pokemon={pokemon}>\n      {pokemon.name}\n    </PokemonRenderer>\n  );\n});\n\n// Render component\n<Choice.Select placeholder=\"Select a pokemon\">\n  {options}\n</Choice.Select>\n";

var CustomRender = React.createClass({
  displayName: 'CustomRender',

  render: function render() {
    var options = _.map(POKEMON, function (pokemon) {
      var value = pokemon.national_id;
      return React.createElement(
        PokemonRenderer,
        { key: value, value: value, pokemon: pokemon },
        pokemon.name
      );
    });

    var sorter = function sorter(list) {
      return _.sortBy(list, 'national_id');
    };

    return React.createElement(
      'section',
      { className: 'tutorial' },
      React.createElement(
        'h3',
        null,
        'Custom Renderer'
      ),
      React.createElement(
        'div',
        { className: 'tutorial__example' },
        React.createElement(
          Choice.Select,
          { placeholder: 'Select a pokemon', sorter: sorter },
          options
        )
      ),
      React.createElement(
        'div',
        { className: 'tutorial__guide' },
        React.createElement(
          'p',
          null,
          'Creating a custom renderer for the options is easy:'
        ),
        React.createElement(
          CodeSnippet,
          { language: 'javascript', toggle: false },
          customExample
        ),
        React.createElement(
          'p',
          null,
          React.createElement(
            'code',
            null,
            'TextHighlight'
          ),
          ' is a component that contains the logic to highlight the text from the search tokens that Sifter returns.'
        ),
        React.createElement(
          'p',
          { className: 'info' },
          'Pokemon data provided by ',
          React.createElement(
            'a',
            { href: 'http://pokeapi.co/' },
            'Pokéapi'
          )
        )
      )
    );
  }
});

module.exports = CustomRender;


/*****************
 ** WEBPACK FOOTER
 ** ./example/components/custom-render.jsx
 ** module id = 9
 ** module chunks = 0
 **/